/**
 * Shopify App Bridge toast (embedded admin). No-op outside embed.
 * @param {string} message
 * @param {{ isError?: boolean }} [opts]
 */
export function showAppToast(message, opts = {}) {
  try {
    const shopify = typeof window !== "undefined" ? window.shopify : null;
    if (shopify?.toast?.show) {
      shopify.toast.show(message, { isError: !!opts.isError });
    }
  } catch {
    /* toast optional outside embedded admin */
  }
}
